import React from "react";
import { Routes, Route } from "react-router-dom";
import GoogleLoginButton from "./components/GoogleLoginButton";
import ProtectedRoute from "./routes/ProtectedRoute";
import Dashboard from "./pages/Dashboard";
import SixFortyLayout from "./layouts/SixFortyLayout";
import AnimationBanner from "./components/AnimationBanner";
import DashboardLayout from "./layouts/DashboardLayout";
import Header from "./components/Header";
import Content from "./components/Content";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import AddNewVehicle from "./pages/AddNewVehicle";
import AddServiceDetails from "./pages/AddServiceDetails";
import ServiceHistory from "./pages/ServiceHistory";
import ServiceHistoryDetails from "./pages/ServiceHistoryDetails";
import ContactUs from "./pages/ContactUs";
import Privacy from "./pages/Privacy";
import Settings from "./pages/Settings";
import Notifications from "./pages/Notifications";
import Login from "./components/Login";
import MaintenanceBanner from "./components/Banner";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";

export default function App() {
  return (
    <Routes>
      {/* Public Route - Login */}
      <Route
        path="/login"
        element={
          <SixFortyLayout
            left={<MaintenanceBanner />}
            right={<Login />}
          />
        }
      />

      {/* Public Route - Forgot Password */}
      <Route
        path="/forgot-password"
        element={<ForgotPassword />}
      />

      {/* Public Route - Reset Password */}
      <Route
        path="/reset-password"
        element={<ResetPassword />}
      />

      {/* Protected Routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Home />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="add-vehicle" element={<AddNewVehicle />} />
        <Route path="add-service" element={<AddServiceDetails />} />
        <Route path="service-history"element={<ServiceHistory />} />
        <Route path="service-history/:id" element={<ServiceHistoryDetails />} />
        <Route path="settings" element={<Settings />} />
        <Route path="notifications" element={<Notifications />} />
        <Route path="contact" element={<ContactUs />} />
        <Route path="privacy" element={<Privacy />} />
      </Route>
    </Routes>
  );
}